// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PublicExposureOffIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="PublicExposureOffIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M4.599 15.901A8 8 0 1 1 15.902 4.598l-1.063 1.063a6.5 6.5 0 0 0-3.1-1.926 12 12 0 0 1 1.54 2.432 2.5 2.5 0 0 0-.845.23 2.2 2.2 0 0 0-.536.36A10.4 10.4 0 0 0 10 4.035 10.4 10.4 0 0 0 7.883 7.25h3.586l-.073.107a14 14 0 0 0-.586 1.019L10.607 8.75h-3.19L7.372 8.99a7.5 7.5 0 0 0-.028 2.51H9l-2.476 2.476A10 10 0 0 1 6.16 13H4.232a6.5 6.5 0 0 0 1.429 1.84zM3.674 11.5h2.153A9 9 0 0 1 5.89 8.75H3.62a6.5 6.5 0 0 0 .054 2.75M6.28 7.25a11.6 11.6 0 0 1 1.981-3.515A6.52 6.52 0 0 0 4.109 7.25z" />
      <path d="M7.973 16.77c-.213.413-.313.675-.288.9a1 1 0 0 0 .421.707c.258.18.693.18 1.564.18h7.66c.87 0 1.306 0 1.564-.18a1 1 0 0 0 .42-.707c.036-.312-.171-.695-.585-1.46l-3.583-6.614-1.107 1.106 3.443 6.355H9.519l2.167-4.001zm9.867 1.005-.003-.008.002.005zm.434-.741.005-.002h.003zm-9.111.733L9.16 17.775v-.002z" />
      <path d="m16.253 8.49 1.613 2.978a8.04 8.04 0 0 0-.357-4.234z" />
      <path d="M13 12h1v2.5h-1z" />
      <path d="M12.875 15.863a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0" />
      <path d="M3.75 16.75 16.478 4.022l1.06 1.06-12.726 12.73z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PublicExposureOffIcon = /* @__PURE__ */ Object.assign(
  PublicExposureOffIconComponent,
  { displayName: 'PublicExposureOffIcon' },
);
